import { getAuxValueTranslationsByAuxValueId } from 'RestAPIs/AuxiliaryValues';

import useResource from 'components/shared/hooks/useResource';

const useGetAuxTranslationsByAuxValueId = (auxValueId) => {
  const { resource } = useResource({
    fetcher: () => getAuxValueTranslationsByAuxValueId(auxValueId),
    shouldFetch: !!auxValueId
  });

  return resource;
};

export default useGetAuxTranslationsByAuxValueId;
